import { getLabelList } from '@/requests/bar'

export default {
    namespaced: true,
    state: {
        serverLabelList:[],
    },
    // getters:{},
    mutations: {
        setLabelInfo(state,labelInfo){
            state.serverLabelList=labelInfo
        }
    },
    actions: {
        async actionUpdateLabelInfo({
            commit
        }) {
            let res= await getLabelList()
            commit('setLabelInfo', res)
        }
    }
}
